import React from "react"
import TrainingImg from "../../images/trainingImg.svg"

const Training = () => {
  return (
    <section className="container mx-auto px-6 py-20">
      <div className="pb-16 flex flex-col md:flex-row items-center">
        <div className="w-full md:w-1/2 font-bold text-secondary text-7xl text-center leading-12 pb-8">
          <h2>Training</h2>
          <h2 className="text-primary">Training</h2>
          <h2>Training</h2>
        </div>
        <div className="w-full md:w-1/2">
          <img src={TrainingImg} alt="" className="mx-auto" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h4 className="text-4xl pb-4 text-center md:text-left">Formation</h4>
          <p>
            We offer <b>ongoing formation</b> and access to various courses so
            you can continue to specialize and educate yourself in different
            areas.
          </p>
        </div>
        <div>
          <h4 className="text-4xl pb-4 text-center md:text-left text-secondary">
            English Class
          </h4>
          <p>
            <b>Avalith offers this Skill</b> to all the members of its team,
            allowing each of them to growth steadily within our organization.
          </p>
        </div>
        <div>
          <h4 className="text-4xl pb-4 text-center md:text-left text-primary md:text-secondary">
            Mentoring
          </h4>
          <p>
            We develop a <b>mentoring program</b> in which professional and
            experienced mentors from the <b>IT industry</b> guide you and follow
            your evolution through planned and effective processes.
          </p>
        </div>
        <div>
          <h4 className="text-4xl pb-4 text-center md:text-left md:text-primary text-secondary">
            Workshops
          </h4>
          <p>
            A learning space in which attendees can share experiences, foster
            the benefits of teamwork and exchange their different ways to
            performing an activity. Always based on IT industry-related topics.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Training
